import React, { useState, useEffect, useContext } from 'react';
import Item from './Item';

const Items = ({ addItem, items, editingItem, setEditingItem }) => {

    let sortedItems = [...(items || [])].sort((a, b) => a.name.localeCompare(b.name));

    return <>
        <h2 style={{ fontSize: 18, marginBottom: 10 }}>Menu Items</h2><div style={{ border: "1px solid #ccc", marginBottom: 10, borderRadius: 4, boxSizing: "border-box", width: "100%", padding: 4 }}>
            <div>

                <div style={{ display: "flex", gap: 4, alignItems: "center", padding: "0", flexWrap: "wrap", alignItems: "flex-end", marginBottom: 4 }}>
                {(sortedItems || []).map((item, i) => <Item item={item} editingItem={editingItem} setEditingItem={setEditingItem} />)}
                </div>
                <div style={{ textAlign: "right" }}>
                    <button onClick={addItem}>Add Item</button>
                </div>
            </div>
        </div>
    </>;

}

export default Items;